import Vue from 'vue'

export default {
  state: {
    announcements: null,
  },
  mutations: {
    setAnnouncements (state, payload) {
      state.announcements = payload
    },
  },
  actions: {
    async loadAnnouncements ({ commit, state, ...ret }, payload = {}) {
      // try {
      //   const { data: { data = [] } } = await Vue.http.get('/v2/announcements?limit=1&order=id&sort=desc')
      //   commit('setAnnouncements', data?.filter(i => !i.expired))
      // } catch (error) {
      //   console.error(error)
      //   // 不再抛出错误，使用默认值
      //   commit('setAnnouncements', [])
      // }
    },
  },
}
